import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { Brand } from "../models/brand";
import { BrandService } from "../services/brand.service";
import { AuthService } from "../core/services/auth.service";

@Injectable()
export class BrandResolver implements Resolve<Brand[]> {
  constructor(
    private service: BrandService,
    private authService: AuthService
  ) {}

  resolve(): Observable<Brand[]> {
    if (this.authService.isLoggedIn) {
      if (this.authService.currentBusiness) {
        return this.service.getBrandByBusinessTypeId(
          this.authService.currentBusiness.businessTypeId
        );
      }
    } else {
      return null;
    }
  }
}
